module.exports = __webpack_public_path__ + "static/media/ic_state.4291aaae.png";